// import { THDUpDownArrows } from '../svgs/up-down-arrows';
// const arrowSVG64 = window.btoa(THDUpDownArrows);
export var THDDatePickerStyles = {
    pickersCalendarHeader: {
        iconButton: {
            '&:hover': {
                backgroundColor: '#fff',
            },
            color: '#f96302',
            '& > span': {
                '& > svg': {
                    fontSize: '30px',
                },
            },
        },
        transitionContainer: {
            height: '23px',
            '& > p': {
                fontSize: '1.8rem',
            },
        },
        dayLabel: {
            fontSize: '12px',
            color: '#333',
        },
    },
    pickersDay: {
        day: {
            borderRadius: '0',
            '&:hover': {
                backgroundColor: '#fff',
                color: '#f96302',
            },
            '& > span > p': {
                fontSize: '12px',
                fontWeight: 'bold',
            },
        },
        daySelected: {
            color: '#333',
            '&:hover': {
                color: '#333',
            },
        },
        current: {},
    },
    dialogActions: {
        root: {
            '& button:hover': {
                backgroundColor: '#f96302',
            },
            '& button:first-of-type': {
                color: '#f96302',
                border: '2px solid #f96302',
                backgroundColor: '#fff',
                boxShadow: 'none',
                '& > span': {
                    height: 'unset',
                },
            },
            '& button:nth-of-type(2)': {
                height: '36px',
                color: '#fff',
                border: '2px solid #f96302',
                backgroundColor: '#f96302',
                '& > span': {
                    height: 'unset',
                },
            },
            '& button:first-of-type > span': {
                color: '#f96302',
                backgroundColor: '#fff',
                // border: '2px solid #f96302',
            },
        },
    },
    pickersToolbar: {
        toolbar: {
            backgroundColor: '#fff',
            '& button': {
                boxShadow: 'none',
                height: '20px',
                '& > span': {
                    paddingLeft: '0px',
                    backgroundColor: '#fff',
                    '& > h4': {
                        backgroundColor: '#fff',
                        color: 'rgba(0, 0, 0, 0.87)',
                    },
                    '& > h6': {
                        backgroundColor: '#fff',
                        color: 'rgba(0, 0, 0, 0.87)',
                    },
                },
            },
            '& button:first-of-type': {
                '& > span > h6': {
                    fontSize: '1.7rem',
                },
                '& > span > h6:after': {
                    // backgroundImage: `url('data:image/svg+xml;base64,${arrowSVG64}')`,
                    backgroundSize: '10px 20px',
                    display: 'inline-block',
                    width: '10px',
                    height: '20px',
                    content: '""',
                    position: 'relative',
                    top: '4px',
                    left: '5px',
                },
            },
            '& button:nth-of-type(2)': {
                cursor: 'default',
                fontSize: '2.125rem',
            },
        },
    },
};
